import axios from "axios";

/**
 * Central Axios instance. The base URL is intentionally configurable so a real
 * backend can be swapped in later without changing UI code.
 *
 * All frontend service modules import this instance.
 */

const BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.REACT_APP_BACKEND_URL
    ? `${process.env.REACT_APP_BACKEND_URL}/api`
    : "/api");

export const api = axios.create({
  baseURL: BASE_URL,
  timeout: 8000,
});

/** Utility: call an async fn; fall back to mock if network fails. */
export async function withFallback(remote, fallback) {
  try {
    const res = await remote();
    return res?.data ?? fallback;
  } catch {
    return fallback;
  }
}
